import { useEffect, useState } from "react";

const API = "/api";
const token = () => localStorage.getItem("token");

const vacio = { categoria: "Proveedores", proveedor: "", descripcion: "", monto: "", metodo_pago: "efectivo", fecha_gasto: "" };

export default function Gastos() {
  const [gastos, setGastos] = useState<any[]>([]);
  const [categorias, setCategorias] = useState<string[]>([]);
  const [form, setForm] = useState<any>(vacio);
  const [editId, setEditId] = useState<number | null>(null);
  const [mostrarForm, setMostrarForm] = useState(false);
  const [filtroCategoria, setFiltroCategoria] = useState("");
  const [fechaDesde, setFechaDesde] = useState("");
  const [fechaHasta, setFechaHasta] = useState("");

  const cargar = () => {
    const params = new URLSearchParams();
    if (filtroCategoria) params.append("categoria", filtroCategoria);
    if (fechaDesde) params.append("fecha_desde", fechaDesde);
    if (fechaHasta) params.append("fecha_hasta", fechaHasta);
    fetch(`${API}/gastos?${params.toString()}`, { headers: { Authorization: `Bearer ${token()}` } })
      .then(r => r.json()).then(d => Array.isArray(d) && setGastos(d)).catch(() => {});
  };
  useEffect(() => {
    fetch(`${API}/gastos/categorias`, { headers: { Authorization: `Bearer ${token()}` } })
      .then(r => r.json()).then(d => Array.isArray(d) && setCategorias(d)).catch(() => {});
  }, []);
  useEffect(() => { cargar(); }, [filtroCategoria, fechaDesde, fechaHasta]);

  const guardar = async () => {
    if (!form.categoria || !form.monto) return;
    const payload = { ...form, monto: Number(form.monto), fecha_gasto: form.fecha_gasto || null };
    const url = editId ? `${API}/gastos/${editId}` : `${API}/gastos`;
    const method = editId ? "PUT" : "POST";
    const r = await fetch(url, {
      method, headers: { "Content-Type": "application/json", Authorization: `Bearer ${token()}` },
      body: JSON.stringify(payload),
    });
    if (r.ok) {
      setForm(vacio); setEditId(null); setMostrarForm(false);
      cargar();
    } else {
      const err = await r.json().catch(() => ({}));
      alert("Error: " + (err.detail || "no se pudo guardar"));
    }
  };

  const editar = (g: any) => {
    setForm({
      categoria: g.categoria, proveedor: g.proveedor || "", descripcion: g.descripcion || "",
      monto: String(g.monto), metodo_pago: g.metodo_pago, fecha_gasto: g.fecha_gasto,
    });
    setEditId(g.id);
    setMostrarForm(true);
  };

  const eliminar = async (g: any) => {
    if (!window.confirm(`¿Eliminar el gasto de ₡${g.monto.toLocaleString()} (${g.categoria})?`)) return;
    const r = await fetch(`${API}/gastos/${g.id}`, { method: "DELETE", headers: { Authorization: `Bearer ${token()}` } });
    if (r.ok) cargar();
  };

  const totalFiltrado = gastos.reduce((s, g) => s + g.monto, 0);

  const input = { width: "100%", padding: "10px 12px", borderRadius: "10px", border: "1.5px solid #e5e7eb", fontSize: "14px", fontFamily: "Nunito,sans-serif", boxSizing: "border-box" as const };
  const label = { display: "block", fontSize: "12px", fontWeight: 700, color: "#6b7280", marginBottom: "4px" };
  const inputChico = { padding: "8px 10px", borderRadius: "8px", border: "1.5px solid #e5e7eb", fontSize: "13px", fontFamily: "Nunito,sans-serif" };

  return (
    <div>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "16px" }}>
        <h1 style={{ fontFamily: "Montserrat,sans-serif", fontSize: "24px", fontWeight: 900, color: "#1a1a2e" }}>
          Gastos
        </h1>
        <button onClick={() => { setForm(vacio); setEditId(null); setMostrarForm(!mostrarForm); }}
          style={{ background: "#0D47A1", color: "#fff", border: "none", borderRadius: "12px", padding: "10px 20px", fontWeight: 700, cursor: "pointer", fontFamily: "Nunito,sans-serif" }}>
          {mostrarForm ? "Cancelar" : "+ Nuevo Gasto"}
        </button>
      </div>

      {mostrarForm && (
        <div style={{ background: "#fff", borderRadius: "16px", padding: "24px", marginBottom: "20px", boxShadow: "0 2px 8px rgba(0,0,0,0.06)" }}>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))", gap: "16px" }}>
            <div>
              <label style={label}>Categoría *</label>
              <select style={input} value={form.categoria} onChange={e => setForm({ ...form, categoria: e.target.value })}>
                {categorias.map(c => <option key={c} value={c}>{c}</option>)}
              </select>
            </div>
            <div>
              <label style={label}>Proveedor {form.categoria === "Proveedores" && "*"}</label>
              <input style={input} placeholder="Nombre del proveedor" value={form.proveedor}
                onChange={e => setForm({ ...form, proveedor: e.target.value })} />
            </div>
            <div>
              <label style={label}>Monto *</label>
              <input type="number" style={input} value={form.monto} onChange={e => setForm({ ...form, monto: e.target.value })} />
            </div>
            <div>
              <label style={label}>Método de pago</label>
              <select style={input} value={form.metodo_pago} onChange={e => setForm({ ...form, metodo_pago: e.target.value })}>
                <option value="efectivo">Efectivo</option>
                <option value="sinpe">Sinpe Móvil</option>
                <option value="transferencia">Transferencia</option>
                <option value="tarjeta">Tarjeta</option>
              </select>
            </div>
            <div>
              <label style={label}>Fecha (opcional, hoy por defecto)</label>
              <input type="date" style={input} value={form.fecha_gasto} onChange={e => setForm({ ...form, fecha_gasto: e.target.value })} />
            </div>
            <div style={{ gridColumn: "1 / -1" }}>
              <label style={label}>Descripción (opcional)</label>
              <input style={input} value={form.descripcion} onChange={e => setForm({ ...form, descripcion: e.target.value })} />
            </div>
          </div>
          <button onClick={guardar} disabled={!form.categoria || !form.monto}
            style={{ marginTop: "16px", background: "#1565C0", color: "#fff", border: "none", borderRadius: "12px", padding: "12px 28px", fontWeight: 800, cursor: (form.categoria && form.monto) ? "pointer" : "not-allowed", opacity: (form.categoria && form.monto) ? 1 : 0.5, fontFamily: "Nunito,sans-serif" }}>
            {editId ? "Guardar cambios" : "Registrar gasto"}
          </button>
        </div>
      )}

      <div style={{ display: "flex", gap: "10px", marginBottom: "16px", flexWrap: "wrap", alignItems: "flex-end" }}>
        <div>
          <div style={label}>Categoría</div>
          <select value={filtroCategoria} onChange={e => setFiltroCategoria(e.target.value)} style={inputChico}>
            <option value="">Todas</option>
            {categorias.map(c => <option key={c} value={c}>{c}</option>)}
          </select>
        </div>
        <div>
          <div style={label}>Desde</div>
          <input type="date" value={fechaDesde} onChange={e => setFechaDesde(e.target.value)} style={inputChico} />
        </div>
        <div>
          <div style={label}>Hasta</div>
          <input type="date" value={fechaHasta} onChange={e => setFechaHasta(e.target.value)} style={inputChico} />
        </div>
        <button onClick={() => { setFiltroCategoria(""); setFechaDesde(""); setFechaHasta(""); }}
          style={{ background: "#fff", color: "#6b7280", border: "1.5px solid #e5e7eb", borderRadius: "8px", padding: "9px 16px", fontWeight: 700, fontSize: "13px", cursor: "pointer", fontFamily: "Nunito,sans-serif" }}>
          Limpiar
        </button>
        <div style={{ marginLeft: "auto", textAlign: "right" }}>
          <div style={label}>Total ({gastos.length})</div>
          <div style={{ fontFamily: "Montserrat,sans-serif", fontWeight: 900, fontSize: "20px", color: "#ef4444" }}>₡{totalFiltrado.toLocaleString()}</div>
        </div>
      </div>

      <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
        {gastos.map(g => (
          <div key={g.id} style={{ background: "#fff", borderRadius: "14px", padding: "14px 18px", boxShadow: "0 2px 8px rgba(0,0,0,0.06)", display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: "12px" }}>
            <div>
              <div style={{ fontWeight: 800, fontSize: "14px" }}>
                {g.categoria}{g.proveedor && ` — ${g.proveedor}`}
              </div>
              <div style={{ fontSize: "12px", color: "#9ca3af", marginTop: "2px" }}>
                {new Date(g.fecha_gasto).toLocaleDateString()} · {g.metodo_pago} · por {g.usuario || "-"}
                {g.descripcion && ` · ${g.descripcion}`}
              </div>
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <div style={{ fontFamily: "Montserrat,sans-serif", fontWeight: 900, fontSize: "16px", color: "#ef4444" }}>₡{g.monto.toLocaleString()}</div>
              <button onClick={() => editar(g)}
                style={{ background: "#EFF6FF", color: "#1565C0", border: "none", borderRadius: "8px", padding: "6px 12px", fontWeight: 700, fontSize: "12px", cursor: "pointer" }}>
                Editar
              </button>
              <button onClick={() => eliminar(g)}
                style={{ background: "#FEF2F2", color: "#991B1B", border: "none", borderRadius: "8px", padding: "6px 12px", fontWeight: 700, fontSize: "12px", cursor: "pointer" }}>
                Eliminar
              </button>
            </div>
          </div>
        ))}
        {gastos.length === 0 && (
          <div style={{ textAlign: "center", padding: "60px", color: "#9ca3af", background: "#fff", borderRadius: "16px" }}>
            No hay gastos registrados con estos filtros
          </div>
        )}
      </div>
    </div>
  );
}
